const Divider = () => <hr className='my-2 w-75' />;
export default Divider;

